import { getTrackIdentifiersDetails } from '../services/accountService'

function fetchFollowRequestDetails(accountNumber, order) {
  return getTrackIdentifiersDetails(accountNumber, order)
}

export default fetchFollowRequestDetails
